import { Button, Flex, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import { unauthorizedPageStore } from '@/stores/global/RootStore';

import s from './UnauthorizedPage.module.scss';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { loginUrl, loadLoginUrlMeta, loadLoginUrl, isPhoneTotpOnlyMode } = unauthorizedPageStore;

  React.useEffect(() => {
    // Режим phone_totp_only: единственный способ входа — телефон, ведём сразу на него.
    if (isPhoneTotpOnlyMode) {
      navigate(ROUTES.auth.phoneLogin.path, { replace: true });

      return;
    }

    loadLoginUrl();
  }, [isPhoneTotpOnlyMode, loadLoginUrl, navigate]);

  const handleLogin = React.useCallback(() => {
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  }, [loginUrl]);

  return (
    <Flex justify="center" className={s.root}>
      <Paper className={s.root__container} radius="md" shadow="sm" withBorder>
        <Stack gap="lg" align="center">
          <Stack gap="xs" align="center">
            <Title order={2} className={s.root__title} ta="center">
              Требуется авторизация
            </Title>
            <Text className={s.root__text} ta="center">
              Войдите в систему, чтобы получить доступ к функциям платформы.
            </Text>
          </Stack>
          <Button
            fullWidth
            onClick={handleLogin}
            className={s.root__button}
            rightSection={<IconArrowRight size={18} />}
            disabled={loadLoginUrlMeta.isLoading || !loginUrl}
            loading={loadLoginUrlMeta.isLoading}
          >
            Войти в систему
          </Button>
        </Stack>
      </Paper>
    </Flex>
  );
};

export default observer(UnauthorizedPage);
